
<template>
<b-tab title="Seguros">
	<h3 class="mt-5 text-center d-none d-lg-block">Seguro Automotriz<small>*</small></h3>
	<h4 class="text-center d-lg-none mt-4 text-center">Seguro Automotriz<small>*</small></h4>
	<p class="text-justify">
		Llévate tu auto asegurado.
	</p>
	<p class="text-justify">
		Obtén tu cotización al momento de adjudicar o facturar y contrata tu seguro automotriz en forma rápida y fácil. 
	</p>
	<b-table-simple borderless class="bg-grey shadow-sm table-responsive">
		<b-tr>
			<b-td colspan="3">
				<h4 class="text-center underline-macal">Características del Seguro Automotriz:</h4>
			</b-td>
		</b-tr>
		<b-tr>
			<b-td width="33%">
				<ul class="macal-ul">
					<li>Daños por accidente, volcamiento e incendio.</li>
					<li>Robo, hurto y uso no autorizado.</li>
					<li>Pérdida total por daños.</li>
					<li>Responsabilidad Civil (daño emergente, lucro cesante y daño moral) UF 700.</li>
					<li>Robo de Accesorios.</li>
					<li>Daños por Riesgos de la Naturaleza.</li>
				</ul>
			</b-td>
			<b-td width="33%">
				<ul class="macal-ul">
					<li>Daños por Granizo.</li>
					<li>Daños por Sismo.</li>
					<li>Daños materiales por Actos Maliciosos.</li>
					<li>Daños Materiales por la Carga.</li>
					<li>Daños a Terceros por la Carga.</li>
					<li>Defensa Penal.</li>
				</ul>
			</b-td>
			<b-td width="33%">
				<ul class="macal-ul">
					<li>Asiento Pasajero (Muerte Accidental).</li>
					<li>Asiento Pasajero (Invalidez Accidental).</li>
					<li>Asistencia Mapfre con auto reemplazo ilimitado.</li>
					<li>Asistencia en Ruta.</li>
					<li>No corras riesgos innecesarios y llévate tu vehículo asegurado desde Macal.</li>
				</ul>
			</b-td>
		</b-tr>
		<b-tr>
			<b-td class="text-center" colspan="3">
				<b-button size="lg" class="mt-4 mb-4 pl-5 pr-5" variant="macal" href="https://www.macal.cl/Form/SeguroVehiculo">SOLICITAR AHORA</b-button>
			</b-td>
		</b-tr>
	</b-table-simple>
	<small class="text-grey">* Producto ofrecido por Mapfre Seguros</small>
</b-tab>
</template>

<script>
  export default {
	name: 'v-tab-insurance',
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>